import { lazy } from 'react';
const PNLPanel = lazy(() => import('../PNLPanel/PNLPanel.jsx'));

const PNLPanelRoutes = [
  {
    path: '/pnlpanel',
    component: PNLPanel
  }
];

export default PNLPanelRoutes;
